// Renewal approval does not imply that the customer has paid.
export function renewalInvoiceForm(draft, customerId) {
  if (String(draft.customerId) !== String(customerId)) throw new Error('This draft belongs to another customer.');
  return {
    invoiceDate: draft.invoiceDate, dueDate: draft.dueDate || '',
    description: `Program renewal: ${draft.programName}`, status: 'PENDING',
    paymentDate: '', paymentMode: '', paymentType: 'NONE', paidAmount: '', notes: draft.notes || '',
    lineItems: [{ itemType: 'PROGRAM', itemId: draft.programId, itemName: draft.programName,
      itemCode: draft.programCode, discountApplicable: draft.discountApplicable,
      quantity: 1, unitPrice: draft.programPrice }]
  };
}
